import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface IconWithTooltipProps {
  /** Tooltip text; also the icon's accessible label. */
  label: string;
  children: React.ReactNode;
}

/** A message status icon (lock, satellite, unverified sender) that explains itself on hover. */
const IconWithTooltip: React.FC<IconWithTooltipProps> = ({ label, children }) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex shrink-0" aria-label={label}>
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p className="text-neutral-500">{label}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default IconWithTooltip;
